import { Component, EventEmitter, forwardRef, Input, Output, ViewEncapsulation } from '@angular/core';
import { ControlContainer, FormGroupDirective, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  selector: 'vfs-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => CheckboxComponent)
    }
  ],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class CheckboxComponent {
  @Input() formControlName?: string = null;
  @Input() checked: boolean;
  @Input() disabled: boolean;
  @Input() id: string;
  @Input() indeterminate: boolean;
  @Input() labelPosition: 'before' | 'after';
  @Input() name: string | null;
  @Input() required: boolean;
  @Input() value: any;
  @Output() changeEvt = new EventEmitter<MatCheckboxChange>();
  @Output() indeterminateChangeEvt = new EventEmitter<boolean>();

  onChange = (rating: number) => {};
  onTouched = () => {};

  writeValue(obj: any): void {
    this.value = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  change(evt: MatCheckboxChange) {
    this.changeEvt.emit(evt);
  }

  indeterminateChange(evt: boolean) {
    this.indeterminateChangeEvt.emit(evt);
  }
}
